export enum Severity {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}
